import { render } from "./Referencia_ContraRef.vue?vue&type=template&id=549487dc"
import script from "./Referencia_ContraRef.vue?vue&type=script&lang=js"
export * from "./Referencia_ContraRef.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__